import React, { useContext, useState } from "react"
import { useSearchParams } from "next/navigation"

const appContext = React.createContext()

export function useAppContext() {
  return useContext(appContext)
}

export function AppProvider({ children }) {
  const searchParams = useSearchParams()

  const [profile, setProfile] = useState({
    embedded:
      searchParams.get("embedded") && searchParams.get("embedded") == "true",
  })

  const [error, setError] = useState(null)

  const clearError = () => setError(null)

  return (
    <appContext.Provider value={{ profile, error, setError, clearError }}>
      {children}
    </appContext.Provider>
  )
}
